import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalEmployeeNotificationsDocument = gql`
  query SalesPortalEmployeeNotifications($employeeUUID: uuid!) {
    employees_by_pk(uuid: $employeeUUID) {
      contact_info {
        uuid
        wants_chat_email
        wants_credit_request_email
        wants_order_email
        wants_order_tracking_notification
        wants_payment_email
      }
      uuid
    }
  }
`;
export function useSalesPortalEmployeeNotificationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalEmployeeNotificationsQuery,
    Types.SalesPortalEmployeeNotificationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalEmployeeNotificationsQuery,
    Types.SalesPortalEmployeeNotificationsQueryVariables
  >(SalesPortalEmployeeNotificationsDocument, options);
}
export function useSalesPortalEmployeeNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalEmployeeNotificationsQuery,
    Types.SalesPortalEmployeeNotificationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalEmployeeNotificationsQuery,
    Types.SalesPortalEmployeeNotificationsQueryVariables
  >(SalesPortalEmployeeNotificationsDocument, options);
}
export type SalesPortalEmployeeNotificationsQueryHookResult = ReturnType<
  typeof useSalesPortalEmployeeNotificationsQuery
>;
export type SalesPortalEmployeeNotificationsLazyQueryHookResult = ReturnType<
  typeof useSalesPortalEmployeeNotificationsLazyQuery
>;
export type SalesPortalEmployeeNotificationsQueryResult = Apollo.QueryResult<
  Types.SalesPortalEmployeeNotificationsQuery,
  Types.SalesPortalEmployeeNotificationsQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalEmployeeNotificationsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalEmployeeNotificationsQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalEmployeeNotificationsQuery,
    Types.SalesPortalEmployeeNotificationsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalEmployeeNotificationsQuery,
    Types.SalesPortalEmployeeNotificationsQueryVariables
  >(SalesPortalEmployeeNotificationsDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalEmployeeNotificationsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalEmployeeNotificationsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalEmployeeNotificationsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalEmployeeNotificationsQuery,
    Types.SalesPortalEmployeeNotificationsQueryVariables
  >(SalesPortalEmployeeNotificationsDocument, lazyOptions);
}
